import React from 'react';
import {
  Flex,
  Text,
  Heading,
  Image,
  Link,
  Box,
  Container,
  VStack,
  Button,
} from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import Willdan from '../../assets/willdan.png';
import Goldenwait from '../../assets/Goldenwait.png';
import Foundryco from '../../assets/Foundryco.png';
import Lootcrate from '../../assets/Lootcrate.png';
import Red from '../../assets/red.png';
import Cisco from '../../assets/linksys.png';
import BeyondMenu from '../../assets/beyondmenu.png';
import Broadcom from '../../assets/broadcomfoundation.png';
import CharmingCharlie from '../../assets/CharmingCharlie.png';
import Alpha from '../../assets/alpha.png';
import Faveable from '../../assets/faveable.png';
import Trees from '../../assets/trees.jpg';

const recentProjects = [
  {
    title: 'Willdan Group, Inc.',
    role: 'Webmaster',
    time: 'May 2024 to Present',
    categories: ['fullstack', 'marketing'],
    companyDescription:
      'A leading provider of professional technical and consulting services specializing in energy, infrastructure, and engineering solutions.',
    description:
      "As the Webmaster at Willdan Group, Inc., I manage and maintain the company's corporate web presence, ensuring high performance, stability, security, and search engine visibility. I coordinate web development initiatives, integrate third-party platforms, and collaborate with key stakeholders to deliver engaging digital experiences.",
    link: 'https://www.willdan.com',
    image: Willdan,
    tech: 'WordPress, PHP, JavaScript, HTML/CSS, Web Performance Optimization, Google Analytics, SEO/Accessibility',
  },
  {
    title: 'Golden Wait',
    role: 'Lead Developer | Co-founder',
    time: '2022 to Present',
    categories: ['fullstack', 'leadership'],
    companyDescription:
      'A SaaS waitlist management and automated marketing platform designed to help dining and hospitality businesses streamline operations.',
    description:
      'Golden Wait is a web application for businesses to manage their  waitlists and grow with automated marketing tools',
    link: 'https://goldenwait.com',
    image: Goldenwait,
    tech: 'React, Node, Firebase (Auth, Firestore), Chakra UI, OpenAI, Twilio, Google Cloud, Cloudflare (Functions, Pages, Workers)',
  },
  {
    title: 'Foundry / IDG',
    role: 'Lead Front-End Developer',
    time: '2022 to 2023',
    categories: ['fullstack', 'leadership'],
    companyDescription:
      "The world's leading media, data, and marketing services company specializing in technology and enterprise media brands.",
    description:
      'My role was to work with a team of developers to build and maintain a suite of websites for the Foundry and IDG brands. I led front-end development in the transition of major media sites from an internal platform to Wordpress VIP.',
    link: 'https://foundryco.com',
    image: Foundryco,
    sites:
      'MacWorld, PCWorld, TechHive, Network World, Computerworld, CIO, CSO, InfoWorld',
    tech: 'Wordpress VIP, PHP, Storybook, React, Google Tag Manager, Google Analytics',
  },
  {
    title: 'The Loot Company',
    role: 'Shopify Developer',
    time: '2020 to 2022',
    categories: ['ecommerce', 'fullstack'],
    companyDescription:
      'A premier pop-culture subscription service delivering themed crates of apparel, collectibles, and exclusive fan merchandise.',
    description:
      'As a front-end developer on this very high traffic subscription box site, I was responsible for building and maintaining the Loot Crate and Loot Vault Shopify sites. This includes the migration of subscription systems.',
    link: 'https://lootcrate.com',
    image: Lootcrate,
    sites: 'Loot Crate, Loot Vault',
    tech: 'Shopify Plus, Liquid, React, JS, Bold Subscriptions, Recurly',
  },
  {
    title: 'Broadcom Foundation',
    role: 'Web Developer',
    time: '2018 to 2023',
    categories: ['fullstack'],
    companyDescription:
      'A non-profit organization advocating for equitable access to STEM education, coding, and digital literacy for middle school students.',
    description:
      'During my time at the Broadcom Foundation, I was responsible for the development and maintenance of the foundation website. I also managed the development of the Broadcom MASTERS website.',
    link: 'https://broadcomfoundation.org',
    image: Broadcom,
    tech: 'Wordpress, PHP, JS',
  },
  {
    title: 'Charming Charlie',
    role: 'Shopify Developer',
    time: '2020 to 2021',
    categories: ['ecommerce'],
    companyDescription:
      'A nationwide fashion retailer and accessories brand renowned for organizing its extensive collections colorfully by shade.',
    description:
      'I designed and built the Charming Charlie Shopify website for this large fashion retailer.',
    link: 'https://charmingcharlie.com',
    image: CharmingCharlie,
    tech: 'Shopify Plus, Liquid',
  },
  {
    title: 'Beyond Menu',
    role: 'Wordpress Developer',
    time: '2020 to 2023',
    categories: ['fullstack', 'marketing'],
    companyDescription:
      'A prominent online food ordering portal and delivery marketplace connecting consumers with local restaurants across the US.',
    description:
      'I built and managed the Beyond Menu marketing website for this large food delivery service. I also led the development of a full site redesign.',
    link: 'https://beyondmenu.com',
    image: BeyondMenu,
    tech: 'Wordpress, Elementor Pro, PHP, JS',
  },
  {
    title: 'Alpha Foods',
    role: 'Shopify Developer',
    time: '2020 to 2021',
    categories: ['ecommerce'],
    companyDescription:
      'A fast-growing food brand crafting delicious, convenient, and accessible plant-based meals and meat alternatives.',
    description:
      'I was responsible for front-end development for the Alpha Foods Shopify website. I also managed the development of the Alpha Foods subscription site.',
    link: 'https://eatalphafoods.com',
    image: Alpha,
    tech: 'Shopify Plus, Liquid, JS, Bold Subscriptions',
  },
  {
    title: 'Faveable',
    role: 'Lead Developer | Co-founder',
    time: '2014 to 2020',
    categories: ['fullstack', 'leadership', 'marketing'],
    companyDescription:
      'An online technology and lifestyle publication providing in-depth product reviews, buying guides, and expert recommendations.',
    description:
      'As a co-founder, I led development of the Faveable website, a product review and comparison site. With over 300k monthly users, I was responsible for the growth of the site through digital marketing and growth tools. We sold the site in 2020.',
    image: Faveable,
    tech: 'LAMP, JS, Digital Marketing, growth tools',
  },
  {
    title: 'RED Digital Cinema',
    role: 'Director of Web & E-commerce',
    time: '2015 to 2018',
    categories: ['ecommerce', 'leadership', 'marketing'],
    companyDescription:
      'An industry-leading manufacturer of high-end digital cinematography cameras and workflow solutions for professional filmmakers.',
    description:
      'As the Director of Web & E-commerce, I led the team that was responsible for the development and management of RED websites.  Through these sites, we sold high-value RED cameras and accessories. I also managed the development of the RED Studios Hollywood website.',
    link: 'https://red.com',
    image: Red,
    sites: 'RED, RED Studios Hollywood',
    tech: 'Ruby on Rails, custom e-commerce platform, Digital Marketing, growth tools',
  },
  {
    title: 'Cisco Systems',
    role: 'Interactive Development Manager',
    time: '2008 to 2014',
    categories: ['ecommerce', 'leadership', 'marketing'],
    companyDescription:
      'A global technology conglomerate and worldwide leader in networking, IT infrastructure, and communications technology.',
    description:
      "At the Cisco Consumer Business Group, I was responsible for the Web team that developed and managed the consumer side of Cisco's business the Linksys website. I also led the development of the Linksys E-commerce platform. Along with this, I managed consumer sites that were acquired by Cisco, including Pure Digital (Flip Video), and NetworkMagic.",
    link: 'https://linksys.com',
    image: Cisco,
    sites: 'Linksys, Flip Video, NetworkMagic',
    tech: 'HTML, CSS, JS, Java, Google Analytics, Digital Marketing, E-commerce',
  },
];

const filters = [
  { id: 'all', label: 'All Projects' },
  { id: 'leadership', label: 'Leadership' },
  { id: 'fullstack', label: 'Full-Stack' },
  { id: 'ecommerce', label: 'E-Commerce' },
  { id: 'marketing', label: 'Growth & Marketing' },
];

function Index() {
  const [activeFilter, setActiveFilter] = React.useState('all');

  const filteredProjects = activeFilter === 'all'
    ? recentProjects
    : recentProjects.filter(project => project.categories && project.categories.includes(activeFilter));

  return (
    <Box bg={'#070709'} minH={'100vh'} color={'white'} overflow={'hidden'} position={'relative'}>
      {/* Background Gradients */}
      <Box
        position={'absolute'}
        top={'0%'}
        left={'-10%'}
        w={'50vw'}
        h={'50vw'}
        borderRadius={'full'}
        bg={'radial-gradient(circle, rgba(239, 68, 68, 0.08) 0%, rgba(0,0,0,0) 70%)'}
        filter={'blur(80px)'}
        zIndex={0}
        pointerEvents={'none'}
      />
      <Box
        position={'absolute'}
        top={'40%'}
        right={'-15%'}
        w={'60vw'}
        h={'60vw'}
        borderRadius={'full'}
        bg={'radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, rgba(0,0,0,0) 70%)'}
        filter={'blur(90px)'}
        zIndex={0}
        pointerEvents={'none'}
      />

      <Container maxW={'6xl'} py={16} position={'relative'} zIndex={1}>
        {/* PAGE HEADER */}
        <VStack spacing={4} align={'center'} textAlign={'center'} mb={12}>
          <Heading
            as={'h1'}
            fontSize={{ base: '4xl', md: '5xl' }}
            fontWeight={900}
            letterSpacing={'wide'}
            textTransform={'uppercase'}
          >
            My{' '}
            <Text as={'span'} bgGradient={'linear(to-r, red.500, red.400)'} bgClip={'text'}>
              Work History
            </Text>
          </Heading>
          <Text fontSize={'lg'} color={'whiteAlpha.600'} maxW={'2xl'}>
            A timeline of technical leadership, full-stack engineering, and high-scale digital commerce platforms built over the last two decades.
          </Text>
        </VStack>

        {/* CATEGORIES FILTER */}
        <Flex
          justify={'center'}
          wrap={'wrap'}
          gap={2}
          mb={16}
          p={1.5}
          bg={'whiteAlpha.50'}
          borderRadius={{ base: '2xl', md: 'full' }}
          maxW={'fit-content'}
          mx={'auto'}
          border={'1px solid'}
          borderColor={'whiteAlpha.100'}
        >
          {filters.map(filter => {
            const isActive = activeFilter === filter.id;
            return (
              <Button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                size={'md'}
                borderRadius={'full'}
                variant={'ghost'}
                bg={isActive ? 'red.500' : 'transparent'}
                color={isActive ? 'white' : 'whiteAlpha.700'}
                fontWeight={700}
                _hover={{
                  bg: isActive ? 'red.600' : 'whiteAlpha.100',
                  color: 'white',
                }}
                _active={{
                  bg: isActive ? 'red.700' : 'whiteAlpha.200',
                }}
                transition={'all 0.2s'}
              >
                {filter.label}
              </Button>
            );
          })}
        </Flex>

        {/* WORK ITEMS LIST */}
        <VStack spacing={12} w={'full'}>
          {filteredProjects.map((project, index) => {
            const isEven = index % 2 === 0;
            return (
              <Flex
                key={project.title}
                direction={{ base: 'column', lg: isEven ? 'row' : 'row-reverse' }}
                bg={'whiteAlpha.50'}
                backdropFilter={'blur(8px)'}
                border={'1px solid'}
                borderColor={'whiteAlpha.100'}
                borderRadius={'3xl'}
                p={{ base: 6, md: 10 }}
                w={'full'}
                gap={{ base: 8, lg: 12 }}
                align={'center'}
                transition={'all 0.3s'}
                _hover={{
                  borderColor: 'red.500',
                  boxShadow: '0 20px 40px rgba(239, 68, 68, 0.05)',
                  bg: 'whiteAlpha.100',
                }}
              >
                {/* Image Section */}
                <Flex
                  flex={1}
                  w={'full'}
                  justify={'center'}
                  overflow={'hidden'}
                  borderRadius={'2xl'}
                  border={'1px solid'}
                  borderColor={'whiteAlpha.100'}
                >
                  <Image
                    src={project.image}
                    alt={project.title}
                    w={'full'}
                    h={'full'}
                    maxH={'320px'}
                    objectFit={'cover'}
                    objectPosition={'top'}
                    transition={'transform 0.5s ease'}
                    _hover={{
                      transform: 'scale(1.03)',
                    }}
                  />
                </Flex>

                {/* Text Content Section */}
                <Flex flexDir={'column'} flex={1.2} w={'full'} align={'flex-start'}>
                  <Flex align={'center'} justify={'space-between'} w={'full'} mb={1}>
                    {project.link ? (
                      <Link
                        href={project.link}
                        fontSize={'3xl'}
                        fontWeight={800}
                        isExternal
                        _hover={{
                          color: 'red.400',
                          textDecoration: 'none',
                        }}
                        display={'inline-flex'}
                        alignItems={'center'}
                        transition={'color 0.2s'}
                      >
                        {project.title}
                        <ExternalLinkIcon mx="2px" boxSize={5} ml={3} />
                      </Link>
                    ) : (
                      <Heading fontSize={'3xl'} fontWeight={800}>
                        {project.title}
                      </Heading>
                    )}
                  </Flex>

                  <Heading fontSize={'lg'} fontWeight={600} color={'red.400'} mb={1}>
                    {project.role}
                  </Heading>
                  
                  <Text fontSize={'sm'} fontWeight={600} color={'whiteAlpha.600'} mb={3}>
                    {project.time}
                  </Text>

                  {project.companyDescription && (
                    <Text fontSize={'sm'} fontStyle={'italic'} color={'whiteAlpha.500'} mb={4}>
                      {project.companyDescription}
                    </Text>
                  )}

                  <Text fontSize={'md'} color={'whiteAlpha.800'} mb={6} lineHeight={'relaxed'}>
                    {project.description}
                  </Text>

                  {project.sites && (
                    <VStack align={'flex-start'} spacing={1} mb={6}>
                      <Heading
                        fontSize={'xs'}
                        fontWeight={800}
                        textTransform={'uppercase'}
                        letterSpacing={'wider'}
                        color={'whiteAlpha.500'}
                      >
                        Featured Sites
                      </Heading>
                      <Text fontSize={'sm'} color={'whiteAlpha.800'}>
                        {project.sites}
                      </Text>
                    </VStack>
                  )}

                  {project.tech && (
                    <VStack align={'flex-start'} spacing={2} w={'full'}>
                      <Heading
                        fontSize={'xs'}
                        fontWeight={800}
                        textTransform={'uppercase'}
                        letterSpacing={'wider'}
                        color={'whiteAlpha.500'}
                      >
                        Tech Stack
                      </Heading>
                      <Flex wrap={'wrap'} gap={2}>
                        {project.tech.split(',').map(t => (
                          <Box
                            key={t.trim()}
                            px={3}
                            py={1}
                            fontSize={'xs'}
                            fontWeight={600}
                            bg={'whiteAlpha.100'}
                            border={'1px solid'}
                            borderColor={'whiteAlpha.100'}
                            borderRadius={'full'}
                            color={'whiteAlpha.900'}
                          >
                            {t.trim()}
                          </Box>
                        ))}
                      </Flex>
                    </VStack>
                  )}
                </Flex>
              </Flex>
            );
          })}
        </VStack>
      </Container>

      {/* Masked Trees Footer */}
      <Box
        backgroundImage={`url(${Trees})`}
        backgroundSize={'cover'}
        backgroundPosition={'center'}
        backgroundRepeat={'no-repeat'}
        h={'25vh'}
        w={'full'}
        position={'relative'}
      >
        <Box
          position={'absolute'}
          inset={0}
          bgGradient={'linear(to-b, #070709 0%, rgba(7,7,9,0.85) 100%)'}
        />
      </Box>
    </Box>
  );
}

export default Index;
